<template>
  <div>
    <div v-if="clerk != null">
        <van-cell title="当前等级" :value="$store.state.ClerkGradeMap[clerk.grade]" />

        <template v-if="autoUpdateGradeSetting.enabled">
            <template v-if="autoUpdateGradeSetting.updateBy == 'ranking'">
                <table class="table margin-top text-center" width="100%" bgcolor="#fff">
                    <tr><th>等级</th><th>名次</th></tr>
                    <tr v-for="(item, index) in gradeList" :key="index">
                        <td>{{item.name}}</td>
                        <td>第{{ item.rankingGe }}名 ~ 第{{ item.rankingLe }}名</td>
                    </tr>
                </table>
            </template>
            <template v-else-if="autoUpdateGradeSetting.updateBy == 'orderAmount' || autoUpdateGradeSetting.updateBy == 'continuedOrderAmount'|| autoUpdateGradeSetting.updateBy == 'accumulativeOrderAmount'">
                <van-cell title="周期订单金额" v-if="autoUpdateGradeSetting.updateBy == 'orderAmount'" :value="'￥'+ formatPrice(amount)" />
                <van-cell title="本周续单金额" v-if="autoUpdateGradeSetting.updateBy == 'continuedOrderAmount'" :value="'￥'+ formatPrice(amount)" />
                <van-cell title="累计订单金额" v-if="autoUpdateGradeSetting.updateBy == 'accumulativeOrderAmount'" :value="'￥'+ formatPrice(amount)" />
                <van-steps class="steps van-hairline--bottom" :active="currStep" direction="vertical">
                    <van-step v-for="(item, index) in gradeList" :key="index" >
<!--                        <van-icon slot="active-icon" name="checked" />-->
<!--                        <van-icon slot="inactive-icon" name="clock-o" />-->
                        <div class="text-lg text-black">{{item.name}}</div>
                        <div class="margin-top-sm text-gray">
                            <template v-if="amount >= item.overAmount">已完成</template>
                            <template v-else>
                              <div v-if="autoUpdateGradeSetting.updateBy == 'orderAmount'">订单金额还差 {{ formatPrice(item.overAmount - amount) }}元</div>
                              <div v-if="autoUpdateGradeSetting.updateBy == 'continuedOrderAmount'">续单金额还差 {{ formatPrice(item.overAmount - amount) }}元</div>
                              <div v-if="autoUpdateGradeSetting.updateBy == 'accumulativeOrderAmount'">累计金额还差 {{ formatPrice(item.overAmount - amount) }}元</div>
                            </template>
                        </div>
                    </van-step>
                </van-steps>
                <van-cell v-if="autoUpdateGradeSetting.enabled && autoUpdateGradeSetting.dayOfWeek!=0" title="下次更新时间" :value="formatDate(nextUpdateTime, 'YYYY-MM-DD')" />
                <van-cell v-else title="更新时间" value="每天" />
            </template>
        </template>
        <template v-else>
            <van-notice-bar
                    wrapable
                    :scrollable="false"
                    left-icon="info-o"
                    text="店铺未开启自动升级功能"
                    color="#1989fa"
                    background="#ecf9ff"
                    style="margin-top: 10px;"
            />
        </template>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import { Cell, CellGroup, Step, Steps, Icon, NoticeBar, Toast, Dialog } from 'vant';
  import Decimal from 'decimal.js';
  import moment from 'moment';
  import { getMyGradeData } from '@/api/clerk/clerk_grade'

  Vue.use(Cell)
      .use(CellGroup)
      .use(Step)
      .use(Steps)
      .use(Icon)
      .use(NoticeBar)
      .use(Toast)
      .use(Dialog)

  export default {
    name: 'clerk-grade',
    data () {
      return {
        clerk: null,
        gradeList: [],
        nextUpdateTime: null,
        amount: null,
        autoUpdateGradeSetting: {},
        currStep: -1
      }
    },
    mounted() {
      this.loadData()
    },
    methods: {
      formatDate(date, format) {
        if (!date) {
          return '';
        }
        if (!format) {
          format = 'YYYY-MM-DD'
        }
        return moment(date).format(format);
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return ''
      },
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getMyGradeData().then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.clerk = data.clerk
            this.gradeList = data.gradeList
            this.nextUpdateTime = data.nextUpdateTime
            this.amount = data.amount
            this.autoUpdateGradeSetting = data.autoUpdateGradeSetting
            if (this.autoUpdateGradeSetting.enabled) {
              if (this.autoUpdateGradeSetting.updateBy == 'ranking') {
                this.gradeList = this.gradeList.reverse()
              } else if (this.autoUpdateGradeSetting.updateBy == 'orderAmount' || this.autoUpdateGradeSetting.updateBy == 'continuedOrderAmount') {
                for (let i in this.gradeList) {
                  if (this.amount >= this.gradeList[i].overAmount) {
                    this.currStep = i
                  }
                }
              }
            }
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>

    .table {
        border-collapse:collapse;
        th, td {
            font-weight: normal;
            padding: 8px 0;
            border: 1px solid #eee;
            border-collapse:collapse;
        }
        th {
            color: #fff;
            background: #40a7ea;
        }
        td {
            color: #666;
        }
    }

    .steps {
        /deep/ &.van-steps--vertical {
            padding: 10px 0 10px 45px;

            .van-step__circle-container {
                left: -20px;
                font-size: 18px;
            }
            .van-step__line {
                left: -20px;
            }
        }
    }
</style>
